
import api from './api'

export default {

    list() {

        return api.get('/markets', {})
            .then( json => json.data )
            
    }
}
